import { Text, useColorModeValue } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SideBarItem from './SideBarItem';

const createLinks = (routes) => {
  const activeColor = useColorModeValue('gray.700', 'white');
  const location = useLocation();
  console.log('routes', routes, location);
  const role = useSelector((state) => state.account.memberRole || 'viewer');

  const activeRoute = (routeName) => (location.pathname === routeName ? 'active' : '');

  return routes
    .filter((r) => !r.hidden)
    .filter((r) => {
      const data = r.loader?.();
      if (!data?.auth) return true;
      if (data.auth.includes(role)) return true;
      return false;
    })
    .map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        return (
          <>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{
                xl: '6px',
              }}
              mx="auto"
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              py="12px"
            >
              {prop.name}
            </Text>
            {createLinks(prop.views)}
          </>
        );
      }
      return (
        <NavLink to={prop.path} key={key}>
          <SideBarItem active={activeRoute(prop.path) === 'active'} icon={prop.icon} name={prop.name} />
        </NavLink>
      );
    });
};

export default createLinks;
